import './BooksEdit.scss'

import { useEffect, useState } from 'react'
import { useParams, useHistory, Link } from 'react-router-dom'
import AwsService from '../../../services/aws.service'
import BooksService from '../../../services/books.service'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import BooksForm from '../components/BookForm/BookForm'
import LessonPlans from '../components/LessonPlans/LessonPlans'

const BooksEdit = () => {
  const { id } = useParams()
  const history = useHistory()
  const MySwal = withReactContent(Swal)

  const [loadedBook, setLoadedBook] = useState({})

  useEffect(() => {
    async function loadBook() {
      const book = await BooksService.getById(id)

      setLoadedBook(book)
    }

    loadBook()
  }, [id])

  function handleDeleteBookPopup() {
    MySwal.fire({
      showCancelButton: true,
      confirmButtonColor: '#E81E47',
      cancelButtonColor: '#fff',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      icon: 'warning',
      title: <span style={{ color: '#FFC107' }}>Deseja excluir o livro?</span>,
      html: <p style={{ color: '#000' }}>Será ação não poderá ser revertida.</p>
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleDeleteBook()
      } else {
        Swal.close()
      }
    })
  }

  async function handleDeleteBook() {
    try {
      if (loadedBook.cover.includes('amazonaws')) {
        const aws = new AwsService()

        const coverFile = await aws.getFiles(loadedBook.id)
        await aws.deleteFile(coverFile[0].Key)
      }

      await BooksService.delete(loadedBook.id)

      MySwal.fire({
        confirmButtonColor: '#87BF40',
        confirmButtonText: <span>Ok</span>,
        icon: 'success',
        title: (
          <span style={{ color: '#FFC107' }}>Livro deletado com sucesso!</span>
        )
      }).then(() => {
        history.push('/books')
      })
    } catch (error) {
      console.error(error)
      MySwal.fire({
        confirmButtonColor: '#87BF40',
        confirmButtonText: <span>Voltar</span>,
        icon: 'error',
        title: (
          <span style={{ color: '#FFC107' }}>
            Não foi possível deletar o livro!
          </span>
        )
      })
    }
  }

  return (
    <div className='content-card'>
      <div className='row page-title edit-book-header'>
        <h1>Editar livro</h1>
        <Link
          to='/books'
          className='button-full go-back-button'
        >
          Voltar
        </Link>
      </div>
      <div className='row content-header'>
        <BooksForm book={loadedBook} />

        <div className='create-book-buttons'>
          <button
            className='button-full btn-remove delete-form-book-button'
            type='button'
            onClick={handleDeleteBookPopup}
          >
            Deletar
          </button>

          <button
            type='submit'
            form='edit-book-form'
            className='button-full btn-edit edit-form-book-button'
          >
            Editar
          </button>
        </div>
      </div>
      <div className='divisor'></div>
      <LessonPlans
        book={loadedBook}
        setLoadedBook={setLoadedBook}
      />
    </div>
  )
}

export default BooksEdit
